import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";

const AuthShell = () => (
  <ClerkAuthProvider>
    <Outlet />
  </ClerkAuthProvider>
);

const AuthPage = ({ children }) => (
  <div className="min-h-screen bg-parchment flex items-center justify-center px-4 py-12">{children}</div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route element={<AuthShell />}>
          <Route path="/admin" element={<Admin />} />
          <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" fallbackRedirectUrl="/admin" withSignUp /></AuthPage>} />
          <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
